import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";

import reportWebVitals from "./reportWebVitals";
import App from "./app";
//import "./fonts.css";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
